import { Button } from "@/components/ui/button"
import { FinalizarCompraTermos } from "./FinalizarCompraTermos"
import { FinalizarCompraResumo } from "./FinalizarCompraResumo"
import { useState } from "react";
import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho";
import { toast } from "@/components/ui/use-toast";
import { useNavigate, useSearchParams } from "react-router-dom";
import CompraService from "@/services/CompraService";
import { DadosCompraSaldoDto } from "@/dtos/Request/RequestDadosCompraCartaoCreditoDto";
import { FormasPagamento } from "@/dtos/FormasPagamento";
import { useAuth } from "@/contexts/AuthProvider";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import AppService from "@/services/AppService";
import StorageUtils from "@/utils/StorageUtils";
import { PresenteadoDto } from "@/services/AcessoService";
import { DrawerPagamentoParaOutraPessoa } from "./DrawerPagamentoParaOutraPessoa";
import { labelSingularLower } from "@/utils/copyTituloBilhete";

interface FinalizarCompraSaldoProps {
    saldoDisponivel: number
    dadosResumo: BuscarCautelasCarrinhoDto,
    token?: string,
    presenteados: PresenteadoDto[],
    handlePresenteados: (action: 'remove' | 'load', presenteado?: PresenteadoDto) => void,
}

export function FinalizarCompraSaldo(props: FinalizarCompraSaldoProps) {
    const [termosAceito, setTermosAceito] = useState(false);
    const [realizandoPagamento, setRealizandoPagamento] = useState(false);
    const navigate = useNavigate();
    const { atualizarSaldoDisponivel } = useAuth();
    const { atualizarQuantidadeCarrinho } = useCarrinho();
    const [searchParams] = useSearchParams();

    async function handleAceitarTermos(termos: boolean) {
        setTermosAceito(termos);
    }

    async function handleFinalizarCompra() {
        try {
            setRealizandoPagamento(true);

            let idPresenteado: number | undefined = undefined;
            const getIdPessoaPresenteada = searchParams.get('idPessoaPresenteada');

            if (getIdPessoaPresenteada) {
                idPresenteado = Number(getIdPessoaPresenteada);
            }

            let idVendedor = StorageUtils.getIdVendedor();

            const dadosPagamento: DadosCompraSaldoDto = {
                Origem: 'Web',
                Cautelas: props.dadosResumo.Cautelas.map(c => c.IdCautela),
                FormaPagamento: FormasPagamento.Saldo,
                IdentificadorDispositivo: await StorageUtils.getDispositivo(),
                IdPresenteado: idPresenteado,
                IdVendedor: idVendedor
            }

            if (props.token) {
                await AppService.FinalizarCompraSaldoApp(dadosPagamento, props.token);
                
                toast({
                    variant: 'success',
                    description: `Feche o navegador e acesse o histórico de compras em seu aplicativo para visualizar seu ${labelSingularLower()}. Em alguns instantes você receberá seu ${labelSingularLower()} por e-mail. Boa sorte!`,
                    title: 'Compra com saldo de crédito',
                    duration: 6000
                })

                StorageUtils.removeIdVendedor();

            } else {
                await CompraService.FinalizarCompraSaldo(dadosPagamento);

                toast({
                    variant: 'success',
                    description: `Sua compra foi confirmada e você já está concorrendo. Em alguns instantes você receberá seu ${labelSingularLower()} por e-mail. Boa sorte!`,
                    title: 'Compra com saldo de crédito',
                    duration: 6000
                })

                StorageUtils.removeIdVendedor();

                atualizarSaldoDisponivel();
                atualizarQuantidadeCarrinho();

                navigate('/Comprar-Titulos');
            }
        } catch (error: any) {
            setRealizandoPagamento(false);
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        }
    }

    return (
        <div className="md:w-5/12">
            <div className="flex flex-col md:flex-row">
                <FinalizarCompraResumo dadosResumo={props.dadosResumo} />
            </div>
            {
                props.saldoDisponivel >= props.dadosResumo.ValorTotal && (
                    <div className="flex flex-col gap-5">
                        <DrawerPagamentoParaOutraPessoa handlePresenteados={props.handlePresenteados} presenteados={props.presenteados} />
                        <FinalizarCompraTermos aceitarTermos={handleAceitarTermos} termosAceito={termosAceito} />
                        <Button
                            className="w-full"
                            size="xl"
                            disabled={!termosAceito || realizandoPagamento}
                            onClick={handleFinalizarCompra}
                            variant="default">
                            {
                                realizandoPagamento ? (<>Finalizando Compra...</>) : (<>Finalizar Compra</>)
                            }
                        </Button>
                    </div>
                )
            }
        </div>
    )
}